import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Paper(): Components {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },

      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  };
}
